// extracted by mini-css-extract-plugin
module.exports = {"header":"_3vxlB","subtitle":"NDvhb","comment":"_2j_j4","button-wrapper":"_28aq6","buttonWrapper":"_28aq6","input-wrapper":"_2VNqv","inputWrapper":"_2VNqv"};